<div class="number-input-container">
  <mat-form-field appearance="outline" class="number-input">
    <input
      matInput
      [maxlength]="maxLength"
      type="number"
      [formControl]="control"
      [min]="min"
      [max]="max"
      placeholder="No limit"
      (keypress)="onlyNumbers($event)"
      (paste)="onPaste($event)"
      pattern="[0-9]*"
    />
    <div matSuffix class="times-suffix" *ngIf="control.value">{{ suffix }}</div>
    <div matSuffix class="number-controls">
      <nb-icon
        class="decrement-icon"
        icon="minus-square-outline"
        (click)="decrement()"
      ></nb-icon>
      <nb-icon
        class="increment-icon"
        icon="plus-square"
        (click)="increment()"
      ></nb-icon>
    </div>
    <mat-error *ngIf="control.invalid && (control.dirty || control.touched)">
      {{ errorMessage }}
    </mat-error>
  </mat-form-field>
  <button 
    mat-button 
    class="reset-button" 
    [class.untouched]="!control.dirty"
    (click)="resetValue()"
  >
    <nb-icon icon="refresh" class="reset-icon"></nb-icon>
    {{ resetButtonText }}
  </button>
</div>
